import React, { useState, useEffect } from "react";
import { Card, Typography,Link, CardContent,Box,Container, CardHeader } from '@material-ui/core';
function AllWeather() {
    const [loading,setLoading]=useState(false);
    const [test,setTest]=useState("none");
    const [data,setData]=useState([]);
    const [time, setTime] = useState(Date.now());
    useEffect(()=>{
        getData();
        const interval = setInterval(() => setTime(Date.now()), 10000);
            return () => {
                clearInterval(interval);
            };
    },[])

    useEffect(()=>{
        if(!loading){
            getData();
        }
    },[time])

    const getData=()=>{
        const url="https://weather.nicosiasailingclub.com/api/weather/parseall";
        setLoading(true);
        fetch(url)
        .then(res => res.text())
        .then(res => {
            const response=JSON.parse(res);
            if(response.success){
                setData(response.data);
                setTest(`Stations loaded ${response.data.length}`);
                setLoading(false);
            }
        } )
        .catch((error)=>{
            console.log("error with API call");
            console.log(error);
            setLoading(false);
        });


    }
    return (
    <>
    <div id="content">
        <Box>
            <Container>
            <Typography variant="h5">Current Weather Conditions {loading?"*":""}</Typography>
            <br/>
        {
            data.map((stationData)=>{
                return <>
                    <Card variant="outlined">
                        <CardContent>
                            <Typography component="h5" variant="h5">{stationData.station}</Typography>
                            <Typography component="h4" variant="h6">
                                    {stationData.data.windSpeed}-{stationData.data.windGust}
                                    <br/>
                                    {stationData.data.windDir}
                            </Typography>
                            <Typography variant="h7">
                                {stationData.data.windSpeedAvg}-{stationData.data.windGustAvg} (max:{stationData.data.windGustMax})
                            </Typography>
                            <Typography variant="h7">
                                <br/><br/>
                                {stationData.data.updated}
                                </Typography>
                        </CardContent>
                    </Card><br/>
                </>
            })
        }
        <br/>
            <div id="footer">
                <Typography variant="h7">Updated Live. No need to refresh.</Typography>
                <br/>
                <Link href="https://nicosiasailingclub.com">nicosiasailingclub.com</Link>
                <br/>
            </div>
        </Container>
        </Box>
    </div>
    </>
);
}
export default AllWeather;